function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "block", "fluid", "placement"],
  _excluded2 = ["children", "initialIsVisible", "restoreFocusOnHide", "placement", "overlay", "overlayRef", "role"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { OverlayTrigger } from '../OverlayTrigger/OverlayTrigger';
import { addSubcomponents } from '../_utils/addSubcomponents';
import { isReactElement } from '../_utils/isReactElement';
import { StyledPopover, StyledPopoverContent } from './Popover.styles';
var Content = /*#__PURE__*/React.forwardRef(function Content(_ref, ref) {
  var children = _ref.children,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPopover, {
    ref: ref
  }, /*#__PURE__*/React.createElement(StyledPopoverContent, _extends({}, props, {
    $block: block,
    $fluid: fluid,
    $placement: placement
  }), children));
});
function PopoverInner(_ref2, ref) {
  var children = _ref2.children,
    _ref2$initialIsVisibl = _ref2.initialIsVisible,
    initialIsVisible = _ref2$initialIsVisibl === void 0 ? false : _ref2$initialIsVisibl,
    _ref2$restoreFocusOnH = _ref2.restoreFocusOnHide,
    restoreFocusOnHide = _ref2$restoreFocusOnH === void 0 ? false : _ref2$restoreFocusOnH,
    _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? 'top' : _ref2$placement,
    overlay = _ref2.overlay,
    overlayRef = _ref2.overlayRef,
    role = _ref2.role,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var overlayNode = isReactElement(overlay) ? /*#__PURE__*/React.cloneElement(overlay, {
    placement: placement
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(OverlayTrigger, _objectSpread(_objectSpread({}, props), {}, {
    initialIsVisible: initialIsVisible,
    overlay: overlayNode,
    placement: placement,
    role: role,
    ref: ref,
    restoreFocusOnHide: restoreFocusOnHide,
    shrinkOverlay: true,
    arrow: true,
    overlayRef: overlayRef
  }), children);
}
var Popover_ = /*#__PURE__*/React.forwardRef(PopoverInner);

// @ts-expect-error
Popover_.displayName = 'Popover';
Content.displayName = 'Popover.Content';

/**

 We use popovers to display more of an item’s information or details on hover.
 This may be used to show additional fields in an item’s form that aren’t shown
 by default in the UI. Oftentimes, there will be a visual queue to indicate that
 more information is available.

 Do not use popovers to display large amounts of information, perform data
 entry, or use as a replacement for an overflow, menu, or modal.

 If you want to show descriptive / educational information about an item,
 use a tooltip.

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-popover--demo)

 @see [Design Guidelines](https://design.procore.com/popover)

*/
export var Popover = addSubcomponents({
  Content: Content
}, Popover_);
//# sourceMappingURL=Popover.js.map